exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-d9d37df2]{background-color:#313e4d;text-align:left;height:15vh;padding:5vh;color:#fff;font-size:30px}.form[data-v-d9d37df2]{display:inline-block;text-align:center;overflow-y:scroll;margin-top:30px;height:60vh;width:80vw;min-height:300px;max-width:500px;padding:30px;background-color:#fefefe;border-radius:10px}.input-form[data-v-d9d37df2]{text-align:left;margin-top:40px}.footer[data-v-d9d37df2]{position:absolute;bottom:0;background-color:#313e4d;height:10vh;width:100vw;padding:2vh;overflow-y:scroll;color:#fff;font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d9d37df2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/AddMember/AddMemberView.vue
// module id = urJw
// module chunks = 3